module.exports = __webpack_public_path__ + "img/pic_1_tc.cd484507.png";